export type PlanStatus = 'free' | 'trial' | 'paid_pilot' | 'suspended' | 'expired';

export type PlanScope = 'user' | 'organisation';

export interface PlanLimits {
  askSourcePerDay: number;
  sourceSummariesPerDay: number;
  createLearningPerDay: number;
}

export const PLAN_STATUSES: PlanStatus[] = [
  'free',
  'trial',
  'paid_pilot',
  'suspended',
  'expired'
];

export const ACTIVE_PLAN_STATUSES: PlanStatus[] = ['free', 'trial', 'paid_pilot'];

export const DEFAULT_USER_PLAN_LIMITS: PlanLimits = {
  askSourcePerDay: 50,
  sourceSummariesPerDay: 10,
  createLearningPerDay: 5
};

export const DEFAULT_ORGANISATION_PLAN_LIMITS: PlanLimits = {
  askSourcePerDay: 500,
  sourceSummariesPerDay: 100,
  createLearningPerDay: 50
};

export function isPlanStatus(value: unknown): value is PlanStatus {
  return typeof value === 'string' && PLAN_STATUSES.includes(value as PlanStatus);
}

export function resolvePlanStatus(value: unknown): PlanStatus {
  return isPlanStatus(value) ? value : 'free';
}

function normaliseLimit(value: unknown, fallback: number): number {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue) || numericValue < 0) {
    return fallback;
  }

  return Math.floor(numericValue);
}

export function resolvePlanLimits(scope: PlanScope, overrides?: Partial<PlanLimits> | null): PlanLimits {
  const defaults = scope === 'organisation'
    ? DEFAULT_ORGANISATION_PLAN_LIMITS
    : DEFAULT_USER_PLAN_LIMITS;

  return {
    askSourcePerDay: normaliseLimit(overrides?.askSourcePerDay, defaults.askSourcePerDay),
    sourceSummariesPerDay: normaliseLimit(overrides?.sourceSummariesPerDay, defaults.sourceSummariesPerDay),
    createLearningPerDay: normaliseLimit(overrides?.createLearningPerDay, defaults.createLearningPerDay)
  };
}

export function formatPlanStatus(status: PlanStatus): string {
  return status === 'paid_pilot'
    ? 'Paid pilot'
    : status.charAt(0).toUpperCase() + status.slice(1);
}
